export default {
    noResults: 'Keine Ergebnisse',
    showAll: 'Alle {count} anzeigen',
    everything: 'Alles',
    defaultPlaceholder: 'Durchsuche alles',
    modulePlaceholder: 'Durchsuche {module}'
}
